import { render } from "./EditCustomerDialog.vue?vue&type=template&id=56020751&scoped=true"
import script from "./EditCustomerDialog.vue?vue&type=script&lang=js"
export * from "./EditCustomerDialog.vue?vue&type=script&lang=js"

import "./EditCustomerDialog.vue?vue&type=style&index=0&id=56020751&scoped=true&lang=css"

import exportComponent from "D:\\Users\\khale\\CookiesBIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56020751"]])

export default __exports__